<div class="d-flex flex-row">
    <app-sidebar></app-sidebar>
    <div class="main-block d-flex flex-col vh-100">
        <app-header></app-header>
        <div class="home-page">
            <router-outlet></router-outlet>
        </div>
        
        <!-- <app-footer></app-footer> -->
    </div>
</div>
<div class="loader" *ngIf="stateService.loaderState$ | async">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</div>

